import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, MapPin, Clock, BookOpen, Heart, Info, ChevronRight, ChevronDown, ChevronUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";

export const ResourcesSection = () => {
  const navigate = useNavigate();
  const [openCategory, setOpenCategory] = useState(null);

  const resources = [
    {
      category: "Forms & Documents",
      icon: FileText,
      items: [
        { name: "Enrollment Application", path: "/resources/enrollment-application" },
        { name: "Medical Release Form", path: "/resources/medical-release" },
        { name: "Field Trip Permission", path: "/resources/field-trip-permission" },
        { name: "Transcript Request", path: "/resources/transcript-request" },
        { name: "Schedule Change Form", path: "/resources/schedule-change" }
      ]
    },
    {
      category: "Transportation",
      icon: MapPin,
      items: [
        { name: "Bus Routes & Schedules", path: "/resources/bus-routes" },
        { name: "Parking Information", path: "/resources/parking-info" },
        { name: "Carpool Program", path: "/resources/carpool-program" },
        { name: "Traffic Guidelines", path: "/resources/traffic-guidelines" }
      ]
    },
    {
      category: "Dining Services",
      icon: Clock,
      items: [
        { name: "Lunch Menu", path: "/resources/lunch-menu" },
        { name: "Nutrition Information", path: "/resources/nutrition-info" },
        { name: "Meal Plan Options", path: "/resources/meal-plans" },
        { name: "Allergy Guidelines", path: "/resources/allergy-guidelines" }
      ]
    },
    {
      category: "Academic Resources",
      icon: BookOpen,
      items: [
        { name: "Course Catalog", path: "/resources/course-catalog" },
        { name: "Tutoring Services", path: "/resources/tutoring" },
        { name: "Study Guides", path: "/resources/study-guides" },
        { name: "Research Databases", path: "/resources/research-databases" },
        { name: "Academic Calendar", path: "/resources/academic-calendar" }
      ]
    },
    {
      category: "Health & Safety",
      icon: Heart,
      items: [
        { name: "Nurse Office Info", path: "/resources/nurse-office" },
        { name: "Immunization Requirements", path: "/resources/immunization" },
        { name: "Emergency Procedures", path: "/resources/emergency-procedures" },
        { name: "Mental Health Resources", path: "/resources/mental-health" }
      ]
    },
    {
      category: "Policies",
      icon: Info,
      items: [
        { name: "Student Handbook", path: "/resources/student-handbook" },
        { name: "Dress Code", path: "/resources/dress-code" },
        { name: "Technology Policy", path: "/resources/technology-policy" },
        { name: "Attendance Policy", path: "/resources/attendance-policy" },
        { name: "Anti-Bullying Policy", path: "/resources/anti-bullying" }
      ]
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-yellow-400 to-orange-400">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-[#002147] mb-8 text-center">Resources</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {resources.map((resource, index) => (
            <Card 
              key={index} 
              className={`cursor-pointer transition-all bg-white ${openCategory === index ? 'ring-2 ring-[#002147]' : ''}`}
              onClick={() => setOpenCategory(openCategory === index ? null : index)}
              data-testid={`resource-${resource.category.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <CardHeader className="pb-2">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                      <resource.icon size={20} className="text-gray-500" />
                    </div>
                    <CardTitle className="text-lg">{resource.category}</CardTitle>
                  </div>
                  {openCategory === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </div>
              </CardHeader>
              {openCategory === index && (
                <CardContent className="pt-0 animate-fadeIn">
                  <ul className="space-y-2">
                    {resource.items.map((item, i) => (
                      <li key={i}>
                        <button 
                          onClick={(e) => { e.stopPropagation(); navigate(item.path); }}
                          className="flex items-center gap-2 text-gray-600 hover:text-[#FF6B00] transition-colors py-1 w-full text-left"
                        >
                          <ChevronRight size={14} /> {item.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;
